var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dropdown-item",
      class: { "dropdown-item_selected": _vm.isSelectedItem },
      on: { click: _vm.handleClick },
    },
    [
      _vm.showLpuLogoPicture
        ? _c("LpuLogoPicture", {
            attrs: {
              "img-class": "dropdown-item__img mr-4",
              alt: "аватар",
              width: "40",
              height: "40",
              files: _vm.lpuLogoFiles,
            },
          })
        : _vm.transformItemData.itemImg
        ? _c("img", {
            staticClass: "dropdown-item__img mr-4",
            attrs: {
              src: _vm.transformItemData.itemImg,
              alt: "аватар",
              width: "40",
              height: "40",
            },
          })
        : _vm.transformItemData.itemIcon
        ? _c("span", {
            staticClass: "icon-secondary--text dropdown-item__icon mr-8",
            class: _vm.transformItemData.itemIcon,
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("div", [
          _c("span", {
            staticClass: "text-body-1",
            class: { "primary--text": _vm.isItemShowMore },
            domProps: { innerHTML: _vm._s(_vm.titleWithMarkedQuery) },
          }),
        ]),
        _vm._v(" "),
        _vm.transformItemData.itemSubtitle
          ? _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.transformItemData.itemSubtitle) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }